
import { GoogleGenAI } from "@google/genai";

const getGeminiClient = () => {
  const apiKey = process.env.API_KEY || process.env.GEMINI_API_KEY;
  if (!apiKey || apiKey === 'your-gemini-api-key') {
    return null;
  }
  return new GoogleGenAI({ apiKey });
};

export const generateBrief = async (content: string): Promise<string> => {
  const ai = getGeminiClient();
  if (!ai) {
    return "AI service not configured. Please add GEMINI_API_KEY to your env.";
  }

  try {
    const model = 'gemini-1.5-flash'; // Using stable model name
    const prompt = `
      You are an expert editorial assistant.
      Summarize the following article content into 3 concise, high-impact bullet points.
      Return ONLY the HTML for the bullet points (<ul><li>...</li></ul>).
      Make it professional and punchy.

      Content:
      ${content.substring(0, 5000)}
    `;

    const modelInstance = ai.getGenerativeModel({ model });
    const result = await modelInstance.generateContent({
      contents: [{ role: 'user', parts: [{ text: prompt }] }]
    });
    const response = await result.response;
    return response.text() || "Could not generate brief.";
  } catch (error) {
    console.error("Gemini Error:", error);
    return "AI service temporarily unavailable.";
  }
};

export const generateRelatedTopics = async (content: string): Promise<string[]> => {
  const ai = getGeminiClient();
  if (!ai) return [];

  try {
    const model = 'gemini-1.5-flash';
    const prompt = `
      Analyze this text and generate 4 related topic tags.
      Return valid JSON string array only. e.g. ["Tech", "AI", "Future"]
      
      Text: ${content.substring(0, 2000)}
    `;

    const modelInstance = ai.getGenerativeModel({ model });
    const result = await modelInstance.generateContent({
      contents: [{ role: 'user', parts: [{ text: prompt }] }]
    });
    const response = await result.response;
    const text = response.text() || "[]";
    return JSON.parse(text);
  } catch (e) {
    console.error(e);
    return [];
  }
};
